import { useState, useEffect } from 'react';
import { updateArticleVotes } from '../firebase.js';
import { SessionVoteManager } from '../utils/sessionStorage';

const useInsightfulVote = (article) => {
  const [hasVoted, setHasVoted] = useState(false);
  const [voteCount, setVoteCount] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (article?.id) {
      setHasVoted(SessionVoteManager.hasVoted(article.id));
      setVoteCount(article.insightfulCount || 0);
    }
  }, [article]);

  const handleVote = async () => {
    // Guard clauses
    if (!article?.id) {
      console.error('No article ID available');
      return;
    }

    if (hasVoted) {
      console.log('Already voted for this article');
      return;
    }

    try {
      setIsUpdating(true);
      const newCount = (article.insightfulCount || 0) + 1;
      
      // Update Firebase with validated ID
      await updateArticleVotes(article.id, newCount);

      // Update local state
      setVoteCount(newCount);
      setHasVoted(true);
      SessionVoteManager.recordVote(article.id);
    } catch (error) {
      console.error('Error updating vote:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  return { hasVoted, voteCount, handleVote, isUpdating };
};

export default useInsightfulVote;